import React, { useContext, useEffect, useState } from "react";
import Header from "../Cpanel/Components/Header";
import Sidebar from "../Cpanel/Components/Sidebar";
import MainContent from "../Cpanel/Components/MainContent";
import Offcanvasbar from "../Cpanel/Components/Offcanvasbar";
import ShopSidebar from "./ShopSidebar";
import { Controller, useForm } from "react-hook-form";
import { fetchData } from "../Cpanel/Components/Utilities";
import { Col, Form, Row } from "react-bootstrap";
import {
  ShopContext,
  ShopListContext,
} from "../StateManagement/Contexts/ShopContext";
import { Dropdown } from "primereact/dropdown";
import Cookies from "js-cookie";
import ShopPanelContainer from "./ShopPanelContainer";
// import Sidebar from "../Components/Sidebar";
// import MainContent from "../Components/MainContent";
// import Header from "../Components/Header";
// import Offcanvasbar from "../Components/Offcanvasbar";

const ShopLayout = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [sidebar, setSidebar] = useState("");
  const [shopInfo, setshopInfo] = useState([]);
  const { shopList: shoplistData } = useContext(ShopListContext);
  const { setShopDataHandler } = useContext(ShopContext);
  const [shopList, setShopList] = useState([]);
  const { shopData } = useContext(ShopContext);
  const mapOptions = (apiResponse) => {
    return apiResponse?.map((item) => ({
      value: item.ShopId,
      label: item.Title,
    }));
  };
  const isShop = "shop";
  const data = mapOptions(shoplistData?.dt);
  const defaultValues = {};
  const {
    handleSubmit,
    watch,
    reset,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

  useEffect(() => {
    // fetchdata();
    setShopList(data);
  }, []);
  const handleApiResponse = (data) => {
    const shopDatas = data?.dt[0];
    setShopDataHandler(shopDatas);
  };
  const fetchShopInfo = (data) => {
    const bodyFormData = new FormData();
    bodyFormData.append("shopid", data);
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("myshopinfo", bodyFormData, handleApiResponse);
  };
  return (
    <div className="d-flex mb-3 h-auto" id="wrapper">
      <Header isShop={true} />
      <ShopSidebar />
      <div
        id="content"
        className="container-fluid pt-5 mt-3 "
      >
        <Row className="d-flex align-items-center">
          <Col className="col-12 col-lg-6 ">
            <Form.Group
              className="mb-3 d-flex flex-column  drop-down-group "
              controlId="formBasicEdu"
            >
              <Form.Label className="fw-bold pb-1">{"فروشگاه"}</Form.Label>
              <Controller
                control={control}
                name={"shopid"}
                render={({ field }) => (
                  <Dropdown
                    value={field.value || ""}
                    options={shopList}
                    onChange={(e) => {
                      field.onChange(e);
                      fetchShopInfo(e.target.value);
                    }}
                    optionValue="value"
                    optionLabel="label"
                    placeholder={"فروشگاه"}
                    name={"shopid"}
                    className="w-75"
                    filter
                  />
                )}
              />
            </Form.Group>
          </Col>
          {/* <Row> */}
          <Col className="col-12 col-lg-6">
            <div className="bg-light fw-bold m-2 p-2 rounded d-flex justify-content-start gap-4">
              <p className="text-gray">حداقل کش بک فروشگاه</p>
              <span className="">{shopData?.MinimumCashBack}</span>
            </div>
          </Col>
          {/* </Row> */}
        </Row>
        <ShopPanelContainer />
      </div>
      {show ? (
        <div className="canvas">
          <Offcanvasbar
            // isShop={isShop}
            // isShopData={"shop"}
            isShop="shop"
            show={show}
            handleClose={handleClose}
            setShow={setShow}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ShopLayout;
